import React from "react";
import MenuItemsPage from "./MenuItemsPage";

const UserHome = () => {
    return (
        <>
            <MenuItemsPage />
        </>
    );
};

export default UserHome;
